import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// Neo DS Components - Load globally
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { RouterOutlet } from '@angular/router';
import '@neo-ds/components/button';
import '@neo-ds/components/checkbox';
import '@neo-ds/components/info-i';
import '@neo-ds/components/input-field';
import '@neo-ds/components/notification';
import '@neo-ds/components/radio-button';
import '@neo-ds/components/tag';
import '@neo-ds/components/modal';
import { ScreenSizeService } from './core/services/screen-size.service';
import { NotificationContainerComponent } from './shared/components/notification-container/notification-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NotificationContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly screenSizeService = inject(ScreenSizeService);

  constructor() {
    this.subscribeToScreenSizeChanges();
  }

  private subscribeToScreenSizeChanges(): void {
    this.breakpointObserver
      .observe([
        Breakpoints.HandsetPortrait,
        Breakpoints.HandsetLandscape,
        Breakpoints.TabletPortrait,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (result) => {
          const isPhoneOrTablet =
            result.breakpoints[Breakpoints.HandsetPortrait] ||
            result.breakpoints[Breakpoints.HandsetLandscape] ||
            result.breakpoints[Breakpoints.TabletPortrait];
          this.screenSizeService.setIsPhoneOrTablet(isPhoneOrTablet);

          const isXlarge = result.breakpoints[Breakpoints.XLarge];
          this.screenSizeService.setIsXlargeScreen(isXlarge);
        },
      });
  }
}
